import { render } from "./LanguageSelection.vue?vue&type=template&id=b53133d6&scoped=true"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"

import "./LanguageSelection.vue?vue&type=style&index=0&id=b53133d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b53133d6"]])

export default __exports__